import { Icon } from '@iconify/react';
import { FieldWrapper } from '@progress/kendo-react-form';
import { InputPrefix, TextBox, TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { Label } from '@progress/kendo-react-labels';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useGuideMe from 'src/hooks/useGuideMe';
import { useContextSelector } from 'use-context-selector';
import useGuideMeSteps from './GuideMeSteps';
import { ViewCatalogsContext } from './ViewCatalogsContext';

const ViewCatalogsFilters = () => {
  const { t } = useTranslation();
  const searchText = useContextSelector(ViewCatalogsContext, (s) => s.searchText);
  const setSearchText = useContextSelector(ViewCatalogsContext, (s) => s.setSearchText);
  const guideMeSteps = useGuideMeSteps();
  const { guideMe } = useGuideMe({
    steps: guideMeSteps,
    guideId: 'browse-catalogs-guide-me',
  });

  const handleSearchChange = useCallback(
    (event: TextBoxChangeEvent) => {
      setSearchText(String(event.value ?? ''));
    },
    [setSearchText]
  );

  return (
    <div className="mb-2 mt-4 flex w-full flex-wrap items-center justify-between gap-4 px-4">
      <div className="flex min-w-[200px] max-w-[350px] flex-[1_1_250px]">
        {/* Filter By */}
        <FieldWrapper className="flex w-full flex-row space-x-2">
          <Label
            editorId="browse-catalogs-filter-input"
            className="flex items-center whitespace-nowrap text-xs font-medium"
          >
            {t('Filter By')}
          </Label>
          <TextBox
            id="browse-catalogs-filter-input"
            max={500}
            maxLength={500}
            size="medium"
            style={{ fontSize: '14px' }}
            placeholder={t('Enter Catalog Name or Account #')}
            width="100%"
            value={searchText}
            onChange={handleSearchChange}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck={false}
            prefix={() => (
              <InputPrefix className="pl-2">
                <Icon height="18" width="18" color="#AAAAAA" icon="lucide:search" />
              </InputPrefix>
            )}
          />
        </FieldWrapper>
      </div>
      {guideMe}
    </div>
  );
};

export default ViewCatalogsFilters;
